import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instalment-version-two',
  templateUrl: './instalment.component.html',
  styleUrls: ['./instalment.component.scss']
})
export class InstalmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
